/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonUserPhotoFromJSON, InternalCommonUserPhotoToJSON, } from './InternalCommonUserPhoto';
/**
 * Check if a given object implements the InternalUserReactionsEmojiResponseV3User interface.
 */
export function instanceOfInternalUserReactionsEmojiResponseV3User(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('subNetworkIds' in value) || value['subNetworkIds'] === undefined)
        return false;
    if (!('extendedUpdatedAt' in value) || value['extendedUpdatedAt'] === undefined)
        return false;
    if (!('photo' in value) || value['photo'] === undefined)
        return false;
    return true;
}
export function InternalUserReactionsEmojiResponseV3UserFromJSON(json) {
    return InternalUserReactionsEmojiResponseV3UserFromJSONTyped(json, false);
}
export function InternalUserReactionsEmojiResponseV3UserFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'email': json['email'],
        'name': json['name'],
        'subNetworkIds': json['sub_network_ids'],
        'extendedUpdatedAt': (new Date(json['extended_updated_at'])),
        'photo': InternalCommonUserPhotoFromJSON(json['photo']),
    };
}
export function InternalUserReactionsEmojiResponseV3UserToJSON(json) {
    return InternalUserReactionsEmojiResponseV3UserToJSONTyped(json, false);
}
export function InternalUserReactionsEmojiResponseV3UserToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'name': value['name'],
        'sub_network_ids': value['subNetworkIds'],
        'extended_updated_at': ((value['extendedUpdatedAt']).toISOString()),
        'photo': InternalCommonUserPhotoToJSON(value['photo']),
    };
}
